export function createEmptyFormData(searchFields, fixedFields = {}) {
  return searchFields.reduce((acc, field) => {
    if (Object.prototype.hasOwnProperty.call(fixedFields, field.name)) {
      acc[field.name] = fixedFields[field.name];
    } else if (field.type === "dateFromTo") {
      acc[field.name] = { startDate: null, endDate: null };
    } else if (field.type === "select" || field.type === "multiselect") {
      acc[field.name] = null;
    } else {
      acc[field.name] = "";
    }
    return acc;
  }, {});
}

function hasValue(value) {
  if (value === "" || value === undefined || value === null) {
    return false;
  }
  if (Array.isArray(value)) {
    return value.length > 0;
  }
  if (typeof value === "object" && value !== null) {
    if ("startDate" in value || "endDate" in value) {
      return Boolean(value.startDate || value.endDate);
    }
  }
  return true;
}

export function resolveSearchCriteria(
  criteria,
  { quickSearchField, isAdvancedPanelOpen },
) {
  if (!criteria) {
    return criteria;
  }

  if (!quickSearchField || !isAdvancedPanelOpen) {
    return { ...criteria };
  }

  const result = { ...criteria };
  delete result[quickSearchField];
  return result;
}

export function getEffectiveQuickSearchValue(quickValue, { isAdvancedPanelOpen }) {
  if (isAdvancedPanelOpen) {
    return "";
  }
  return quickValue ?? "";
}

export function stripAdvancedSearchFilters(
  criteria,
  { searchFields, quickSearchField, initialCriteria },
) {
  const advancedFieldNames = new Set(searchFields.map((field) => field.name));
  const quickSearchValue =
    quickSearchField && hasValue(criteria[quickSearchField])
      ? criteria[quickSearchField]
      : null;

  if (initialCriteria) {
    const result = { ...initialCriteria };
    if (quickSearchValue !== null) {
      result[quickSearchField] = quickSearchValue;
    }
    return result;
  }

  const result = { ...criteria };
  advancedFieldNames.forEach((name) => {
    if (name !== quickSearchField) {
      delete result[name];
    }
  });

  if (quickSearchValue === null && quickSearchField) {
    delete result[quickSearchField];
  }

  return result;
}
